import {
  Card,
  Divider,
  Grid,
  Snackbar,
  Table,
  TableBody,
  TableHead,
  Typography,
  Alert as MuiAlert,
  CardContent,
  TableContainer
} from '@mui/material'
import { useEffect, useState, forwardRef } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import { businessCheck } from '../../utils/utils'
import { loadScript } from './Subscription'

import EntitlementInfoComponent from '../subscriptions/orders/entitlementDetailsDialog'
import CurrentPlanComponent from '../subscriptions/orders/currentPlanDialog'
import BuyNewOrderDrawer from '../subscriptions/orders/buyNewOrderDrawer'
import RenewSubscriptionDrawer from '../subscriptions/orders/renewSubscriptionDrawer'
import PaymentHistory from '../subscriptions/orders/paymenentHistoryDialog'
import PendingOrdersPaymentDrawer from './orders/pendingOrdersPaymentDrawer'
import {
  ConfirmationDialog,
  ErrorScreen,
  SnackBarHideDuration,
  SnackBarTransition,
  StyledTableCell,
  StyledTableRow
} from '../../utils/ui_utils'
import { RAZORPAYKEY } from '../../utils/tsUtils/Env'
import { useFetchEntitlement } from '../../modules/entitlement/entitlementHooks'
import { useCreateRazorpayOrder } from '../../modules/razorpay/razorpayHooks'
import { useFetchById } from '../../modules/plans/planHooks'
import { useSubscriptionOrderTypeFetch } from '../../modules/subscriptionPurchaseOrderType/subsOrderTypeHooks'
import {
  useCancelPurchaseOrderService,
  useCreatePurchaseOrderService,
  useFetchPurchaseOrderService,
  useUpdatePurchaseOrderService
} from '../../modules/subscriptionPurchaseOrderService/purchaseOrderServiceHooks'
import _ from 'lodash'

export var convert = function (str) {
  var date = new Date(str)
  var mnth = `0${date.getMonth() + 1}`.slice(-2)
  var day = `0${date.getDate()}`.slice(-2)
  return [date.getFullYear(), mnth, day].join('-')
}

const formatYmd = (date) => date.toISOString().slice(0, 10)
let TodayDate = formatYmd(new Date())

function Orders() {
  const [page, setPage] = useState(1)
  const [error, setError] = useState(false)
  const [limit, setLimit] = useState(10)
  const [pagecount, setPageCount] = useState(1)
  const [selectedData, setSelectedData] = useState(null)
  const [entitlementData, setEntitlementData] = useState(null)
  const [currentPlan, setCurrentPlan] = useState(null)
  let renewFlag = false
  const [upgradeFlag, setUpgradeFlag] = useState(false)
  let [noOfUsers, setNoOfUsers] = useState(0)
  let [subtotal, setSubTotal] = useState(0)
  let [purchaseForDays, setPurchaseForDays] = useState(0)
  let [total, setTotal] = useState(0)
  let orderId
  let purchase_order_id
  let order_selected = {}
  let [dueDate, setDueDate] = useState(null)
  const history = useNavigate()
  let selectedPlanData
  let [cgstAmt, setCgstAmt] = useState(0)
  let [igstAmt, setIgstAmt] = useState(0)
  let [sgstAmt, setSgstAmt] = useState(0)
  let [net_amount, setNetAmount] = useState(0)

  const [buyUserDrawerVisibility, setBuyUserDrawerVisiblity] = useState(false)
  const [renewDrawerVisibility, setRenewDrawerVisiblity] = useState(false)
  const [paymentHistoryDialogVisibility, setPaymentDialogVisibility] =
    useState(false)
  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)
  const [
    pendingOrderPaymentDrawerVisibility,
    setPendingOrderPaymentDrawerVisibility
  ] = useState(false)
  const handleSnackbarClose = () => {
    setSnackBar(false)
  }

  const { fetchPlanById, fetchPlanByIdData } = useFetchById()
  const { fetchSubscriptionOrderType, subsOrderTypeData } =
    useSubscriptionOrderTypeFetch()
  const {
    fetchLastSuccessPurchaseOrderService,
    fetchPendingPurchaseOrderService,
    fetchPurchaseOrderService,
    fetchPurchaseOrderServiceData,
    fetchLastSuccessPurchaseOrderServiceData,
    fetchPendingPurchaseOrderServiceData,
    fetchPurchaseOrderServiceError,
    fetchPurchaseOrderServiceLoading
  } = useFetchPurchaseOrderService()
  const { createPurchaseOrderService } = useCreatePurchaseOrderService()
  const { updatePurchaseOrderService } = useUpdatePurchaseOrderService()
  const { cancelPurchaseOrderService } = useCancelPurchaseOrderService()
  const {
    fetchEntitlement,
    fetchEntitlementData,
    fetchEntitlementError,
    fetchEntitlementLoading
  } = useFetchEntitlement()
  const { createRazorpayOrder } = useCreateRazorpayOrder()

  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }

  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
  })

  const pageCount = (data1) => {
    let count = Math.ceil(data1 / limit)
    setPageCount(count)
  }

  useEffect(() => {
    businessCheck(history)
    fetchEntitlement()
    let payLoad = {
      pageNumber: page,
      limit: 1,
      status: 'Pending'
    }
    fetchPendingPurchaseOrderService(payLoad)
    let payLoad2 = {
      pageNumber: page,
      limit: 1,
      status: 'Success'
    }
    fetchLastSuccessPurchaseOrderService(payLoad2)
    let params = {
      pageNumber: 1,
      limit: limit
    }
    fetchPurchaseOrderService(params)
    fetchSubscriptionOrderType()
  }, [])

  useEffect(() => {
    async function getPlans(planID) {
      await fetchPlanById(planID)
    }
    if (Object.keys(fetchEntitlementData)?.length > 0) {
      setEntitlementData(fetchEntitlementData)
      let planID = fetchEntitlementData.current_plan._id
      getPlans(planID)
      let dueDate = new Date(fetchEntitlementData.expiry_date)
      dueDate.setDate(dueDate.getDate() - 5)
      dueDate = `${dueDate.getFullYear()}-${
        dueDate.getMonth() + 1
      }-${dueDate.getDate()}`
      setDueDate(dueDate)
    }
  }, [fetchEntitlementData])

  useEffect(() => {
    if (Object.keys(fetchPurchaseOrderServiceData)?.length > 0) {
      pageCount(fetchPurchaseOrderServiceData.total)
    }
  }, [fetchPurchaseOrderServiceData])

  const fetchEntitlementOnError = () => {
    fetchEntitlement()
    let payLoad = {
      pageNumber: page,
      limit: 1,
      status: 'Pending'
    }
    fetchPendingPurchaseOrderService(payLoad)
    let payLoad2 = {
      pageNumber: page,
      limit: 1,
      status: 'Success'
    }
    fetchLastSuccessPurchaseOrderService(payLoad2)
    let params = {
      pageNumber: 1,
      limit: limit
    }
    fetchPurchaseOrderService(params)
    fetchSubscriptionOrderType()
  }

  let renewOrderObj = {
    no_of_users: entitlementData?.max_users,
    purchased_items: [
      {
        plan_id: selectedPlanData?._id,
        unit_price: selectedPlanData?.price_per_user,
        qty: entitlementData?.max_users,
        free_users: selectedPlanData?.free_users,
        fixed_charge: selectedPlanData?.fixed_charge,
        cgst: selectedPlanData?.igst / 2,
        sgst: selectedPlanData?.igst / 2,
        igst: selectedPlanData?.igst,
        sgst_amount: sgstAmt,
        cgst_amount: cgstAmt,
        igst_amount: igstAmt
      }
    ]
  }

  const onPayPerUserPurchaseOrderSave = async () => {
    let returnSuccess = 1
    let body = null
    if (renewFlag === true) {
      body = renewOrderObj
    } else if (upgradeFlag === true) {
      body = orderObj
    }
    await createPurchaseOrderService(body, (success, error, orderData) => {
      if (error) {
        toastMessage('Subscription purchase not successful', 'error')
        returnSuccess = 0
      } else {
        let response = orderData
        purchase_order_id = response.id
        toastMessage('Successfully Saved Order', 'success')
      }
    })
    return returnSuccess
  }

  const calculateRenewPlan = async () => {
    let business_state = localStorage.getItem('BusinessDetails')
    selectedPlanData = fetchPlanByIdData
    let entitlementRecord = fetchEntitlementData
    let Sub_total = 0
    let Total = 0
    let _cgst = 0
    let _sgst = 0
    let _igst = 0
    let _net_amount = 0
    let Credit_note = entitlementRecord.credit_note //localStorage.getItem('credit_note')
    setPurchaseForDays(selectedPlanData?.plan_duration)
    if (entitlementRecord?.max_users <= selectedPlanData?.max_users) {
      if (selectedPlanData?.free_users === 0) {
        Sub_total =
          selectedPlanData?.fixed_charge +
          entitlementRecord?.max_users * selectedPlanData?.price_per_user
      } else if (selectedPlanData?.fixed_charge === 0) {
        Sub_total =
          entitlementRecord?.max_users * selectedPlanData?.price_per_user
      } else if (entitlementRecord?.max_users > selectedPlanData?.free_users) {
        let diffuser =
          entitlementRecord?.max_users - selectedPlanData?.free_users
        Sub_total =
          selectedPlanData?.fixed_charge +
          diffuser * selectedPlanData?.price_per_user
      } else {
        Sub_total = selectedPlanData?.fixed_charge
      }

      if (business_state == 'Karnataka') {
        _cgst = (Sub_total * (selectedPlanData.igst / 2)) / 100
        _sgst = (Sub_total * (selectedPlanData.igst / 2)) / 100
      } else {
        _igst = (Sub_total * selectedPlanData.igst) / 100
      }
      Total = (Sub_total + _cgst + _sgst + _igst).toFixed(0)
      if (Credit_note > Total) {
        _net_amount = 0
      } else if (Credit_note == Total) {
        _net_amount = (Total - Credit_note).toFixed(0)
      } else if (Credit_note < Total) {
        _net_amount = (Total - Credit_note).toFixed(0)
      }
      setSubTotal(Sub_total)
      setCgstAmt(_cgst)
      setSgstAmt(_sgst)
      setIgstAmt(_igst)
      setTotal(Total)
      setNetAmount(_net_amount)
      return _net_amount
    }
    toastMessage(
      `Maximum Users is only ${selectedPlanData?.max_users}`,
      'warning'
    )
  }

  const [openCancelPopup, setOpenCancelPopup] = useState(false)
  const [confirmCancelPopup, setConfirmCancelPopup] = useState(false)

  const handleClickOpenCancelPopup = () => {
    setOpenCancelPopup(true)
  }

  const handleCloseOpenCancelPopup = () => {
    setOpenCancelPopup(false)
  }

  const handleClickOpenConfirmCancelPopup = () => {
    setOpenCancelPopup(false)
    setConfirmCancelPopup(true)
  }

  const handleCloseConfirmCancelPopup = () => {
    setConfirmCancelPopup(false)
  }

  const onConfirmCancelPlanClick = async () => {
    await cancelPurchaseOrderService((success, error) => {
      if (error) {
        toastMessage('Plan cancelled failed', 'error')
      } else {
        toastMessage('Plan cancelled successfully', 'success')
        handleCloseConfirmCancelPopup()
        fetchEntitlement()
        history('/myAccount/subscriptionplans')
      }
    })
  }

  function PlanCancelPopUpDialog() {
    return (
      <div>
        <ConfirmationDialog
          visibility={openCancelPopup}
          okText="Continue"
          cancelText="Cancel"
          message="Before changing Subscription plan, current plan should be cancelled."
          title="Information"
          onCancel={handleCloseOpenCancelPopup}
          onOk={handleClickOpenConfirmCancelPopup}
        />

        <ConfirmationDialog
          visibility={confirmCancelPopup}
          okText="Yes"
          cancelText="No"
          message="Do you want to Proceed?"
          title="Confirmation"
          onCancel={handleCloseConfirmCancelPopup}
          onOk={() => onConfirmCancelPlanClick()}
        />
      </div>
    )
  }

  const onClickBuyUsers = async () => {
    setUpgradeFlag(true)
    setBuyUserDrawerVisiblity(true)
  }

  const calculateBuyNewUserOrder = (value) => {
    setCurrentPlan(fetchPlanByIdData)
    let business_state = localStorage.getItem('BusinessDetails')
    let Sub_total = 0
    let Total = 0
    let _cgst = 0
    let _sgst = 0
    let _igst = 0
    let _net_amount = 0
    let Credit_note = fetchEntitlementData.credit_note //localStorage.getItem('credit_note')

    let CurrentUsers = fetchEntitlementData?.max_users
    let maxusers = fetchPlanByIdData?.max_users - CurrentUsers
    let expiryDateOfPlan = new Date(fetchEntitlementData?.expiry_date)
    expiryDateOfPlan.setHours(0)
    expiryDateOfPlan.setMinutes(0)
    expiryDateOfPlan.setSeconds(0)
    expiryDateOfPlan.setMilliseconds(0)

    let tdayDate = new Date()
    tdayDate.setHours(0)
    tdayDate.setMinutes(0)
    tdayDate.setSeconds(0)
    tdayDate.setMilliseconds(0)

    let diffDays1 =
      Math.round(expiryDateOfPlan.getTime() - tdayDate.getTime()) /
      (1000 * 60 * 60 * 24)
    let diffDays = diffDays1.toFixed(0)
    let price_per_day =
      fetchPlanByIdData?.price_per_user / fetchPlanByIdData?.plan_duration
    if (value <= maxusers) {
      if (diffDays > 0) {
        setNoOfUsers(value)
        setPurchaseForDays(diffDays)
        Sub_total = value * (price_per_day * diffDays)
        if (business_state == 'Karnataka') {
          _cgst = (Sub_total * (fetchPlanByIdData?.igst / 2)) / 100
          _sgst = (Sub_total * (fetchPlanByIdData?.igst / 2)) / 100
        } else {
          _igst = (Sub_total * fetchPlanByIdData?.igst) / 100
        }
        Total = Sub_total + _cgst + _sgst + _igst

        if (Credit_note > Total) {
          _net_amount = 0
        } else if (Credit_note == Total) {
          _net_amount = Total - Credit_note
        } else if (Credit_note < Total) {
          _net_amount = Total - Credit_note
        }

        _net_amount = parseInt(_net_amount.toFixed(0))
        Sub_total = Sub_total.toFixed(0)
        Total = Total.toFixed(0)

        setCgstAmt(_cgst)
        setSgstAmt(_sgst)
        setIgstAmt(_igst)
        setTotal(Total)
        setSubTotal(Sub_total)
        setNetAmount(_net_amount)
      } else {
        toastMessage('Your Plan Already Expired', 'warning')
      }
    } else {
      toastMessage(`You can only create upto ${maxusers} Users`, 'warning')
    }
  }

  const preparerenewObj = async () => {
    selectedPlanData = fetchPlanByIdData
    let purchase_order_type
    for (let i = 0; i < subsOrderTypeData?.length; i++) {
      if (subsOrderTypeData[i].short_name === 'Renew') {
        purchase_order_type = subsOrderTypeData[i]
        break
      }
    }

    let renewOrderObj1 = {
      no_of_users: fetchEntitlementData?.max_users,
      total_amount: parseInt(total),
      credit_note: fetchEntitlementData.credit_note,
      net_amount: parseInt(net_amount),
      purchase_for_days: parseInt(purchaseForDays),
      purchased_items: [
        {
          plan_id: fetchPlanByIdData?._id,
          purchase_type_id: purchase_order_type?._id,
          unit_price: selectedPlanData?.price_per_user,
          qty: fetchEntitlementData?.max_users,
          free_users: selectedPlanData?.free_users,
          fixed_charge: selectedPlanData?.fixed_charge,
          cgst: selectedPlanData?.igst / 2,
          sgst: selectedPlanData?.igst / 2,
          igst: selectedPlanData?.igst,
          sgst_amount: sgstAmt,
          cgst_amount: cgstAmt,
          igst_amount: igstAmt
        }
      ]
    }
    renewOrderObj = renewOrderObj1
  }

  const onClickRenewOrder = async () => {
    await calculateRenewPlan()
    setRenewDrawerVisiblity(true)
  }

  const displayRenewalRazorpay = async () => {
    let usersCount = fetchEntitlementData?.max_users
    if (usersCount == 0 || isNaN(usersCount)) return

    setRenewDrawerVisiblity(false)
    renewFlag = true
    setUpgradeFlag(false)
    await preparerenewObj()
    if (net_amount > 0) {
      await displayRazorpay(net_amount)
    } else if (net_amount === 0) {
      updatePurchaseOrder()
    }
  }

  const updatePurchaseOrder = async () => {
    let obj
    if (upgradeFlag === true) {
      obj = orderObj
    } else {
      obj = renewOrderObj
    }
    let resp
    let updateRecord = false

    await createPurchaseOrderService(obj, (success, error, data) => {
      if (error) {
        toastMessage('Subscription Purchase order creation failed', 'error')
      } else {
        resp = data
        updateRecord = true
      }
    })

    if (updateRecord) {
      obj.id = resp.id
      obj.payment_through = 'Credit Note'
      obj.status = 'Success'
      await updatePurchaseOrderService(obj, (success, error) => {
        if (error) {
          toastMessage('Subscription purchase not successful', 'error')
        } else {
          setPendingOrderPaymentDrawerVisibility(false)
          setBuyUserDrawerVisiblity(false)
          toastMessage('Successfully Updated Order', 'success')
          let payLoad = {
            pageNumber: 1,
            limit: 100,
            status: 'Pending'
          }
          fetchPendingPurchaseOrderService(payLoad)
          delete payLoad.status
          payLoad.limit = 10
          fetchPurchaseOrderService(payLoad)
          fetchEntitlement()
        }
      })
    }
  }

  let orderObj = {
    no_of_users: parseInt(noOfUsers),
    total_amount: parseInt(total),
    credit_note: fetchEntitlementData.credit_note,
    net_amount: parseInt(net_amount),
    purchase_for_days: parseInt(purchaseForDays),
    purchased_items: [
      {
        plan_id: selectedData?.purchased_items[0]?.plan?._id,
        purchase_type_id: selectedData?.purchased_items[0]?.purchasetype?._id,
        unit_price: selectedData?.purchased_items[0]?.unit_price,
        qty: parseInt(noOfUsers),
        free_users: selectedData?.purchased_items[0]?.free_users,
        fixed_charge: selectedData?.purchased_items[0]?.fixed_charge,
        cgst: selectedData?.purchased_items[0].igst / 2,
        sgst: selectedData?.purchased_items[0].igst / 2,
        igst: selectedData?.purchased_items[0].igst,
        sgst_amount: sgstAmt,
        cgst_amount: cgstAmt,
        igst_amount: igstAmt
      }
    ]
  }

  const onOrderCancelClick = async () => {
    orderObj.id = selectedData._id
    const body = orderObj
    body.status = 'Cancelled'
    await updatePurchaseOrderService(body, (success, error) => {
      if (error) {
        toastMessage('Order is not cancelled. Try again.', 'error')
      } else {
        toastMessage('Order is cancelled', 'success')
        let payLoad = {
          pageNumber: 1,
          limit: 10
        }
        fetchPurchaseOrderService(payLoad)
        payLoad.limit = 100
        payLoad.status = 'Pending'
        fetchPendingPurchaseOrderService(payLoad)
        setPendingOrderPaymentDrawerVisibility(false)
      }
    })
  }

  const onOrderUpdateClick = async () => {
    let returnSuccess = 1
    orderObj.id = selectedData._id
    const body = orderObj
    await updatePurchaseOrderService(body, (success, error) => {
      if (error) {
        toastMessage('Subscription purchase not successful', 'error')
        returnSuccess = 0
      } else {
        toastMessage('Successfully Update Order', 'success')
        let payLoad = {
          pageNumber: 1,
          limit: 10
        }
        fetchPurchaseOrderService(payLoad)
        payLoad.limit = 100
        payLoad.status = 'Pending'
        fetchPendingPurchaseOrderService(payLoad)
        setPendingOrderPaymentDrawerVisibility(false)
      }
    })
    return returnSuccess
  }

  const onPendingOrderUpdateClick = async () => {
    orderObj.id = selectedData._id
    orderObj.payment_through = 'Credit Note'
    orderObj.status = 'Success'

    await updatePurchaseOrderService(orderObj, (success, error) => {
      if (error) {
        toastMessage('Subscription purchase not successful', 'error')
      } else {
        setPendingOrderPaymentDrawerVisibility(false)
        toastMessage('Successfully Update Order', 'success')
        let payLoad = {
          pageNumber: 1,
          limit: 100,
          status: 'Pending'
        }
        fetchPendingPurchaseOrderService(payLoad)
        delete payLoad.status
        payLoad.limit = 10
        fetchPurchaseOrderService(payLoad)
        fetchEntitlement()
      }
    })
  }

  const calculateOrderBeforeLoad = (e) => {
    let business_state = localStorage.getItem('BusinessDetails')
    let Sub_total = 0
    let Total = 0
    let _cgst = 0
    let _sgst = 0
    let _igst = 0
    let _net_amount = 0
    let Credit_note = fetchEntitlementData.credit_note //localStorage.getItem('credit_note')
    setPurchaseForDays(order_selected.purchased_items[0]?.plan.plan_duration)
    if (order_selected?.purchased_items[0]?.free_users === 0) {
      Sub_total =
        order_selected?.purchased_items[0]?.fixed_charge +
        e * order_selected?.purchased_items[0]?.unit_price
    } else if (order_selected?.purchased_items[0]?.fixed_charge === 0) {
      Sub_total = e * order_selected?.purchased_items[0]?.unit_price
    } else if (e > order_selected?.purchased_items[0]?.free_users) {
      let diffuser = e - order_selected?.purchased_items[0]?.free_users
      Sub_total =
        order_selected?.purchased_items[0]?.fixed_charge +
        diffuser * order_selected?.purchased_items[0]?.unit_price
    } else {
      Sub_total = order_selected?.purchased_items[0]?.fixed_charge
    }
    if (business_state == 'Karnataka') {
      _cgst = (Sub_total * (order_selected?.purchased_items[0]?.igst / 2)) / 100
      _sgst = (Sub_total * (order_selected?.purchased_items[0]?.igst / 2)) / 100
    } else {
      _igst = (Sub_total * order_selected?.purchased_items[0]?.igst) / 100
    }
    Total = Sub_total + _cgst + _sgst + _igst
    if (Credit_note > Total) {
      _net_amount = 0
    } else if (Credit_note == Total) {
      _net_amount = Total - Credit_note
    } else if (Credit_note < Total) {
      _net_amount = Total - Credit_note
    }
    setCgstAmt(_cgst)
    setSgstAmt(_sgst)
    setIgstAmt(_igst)
    setTotal(Total)
    setSubTotal(Sub_total)
    setNetAmount(_net_amount)
  }

  const [payment_option, setPayment_Option] = useState('Razorpay')

  async function displayRazorpay(amount = 0) {
    const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js')
    let totalAmount
    if (!res) {
      alert('Razorpay SDK failed to load. Are you online?')
      return
    }
    if (amount === 0) {
      totalAmount = parseInt(net_amount)
    } else {
      totalAmount = parseInt(amount)
    }
    let timestamp = Math.floor(Date.now() / 1000)
    let body = {
      receipt: 'xpos_receipt#' + timestamp,
      amount: totalAmount,
      payment_capture: true
    }

    let data
    await createRazorpayOrder(body, (success, error, orderData) => {
      if (error) {
        toastMessage('Unable to create order. Try later', 'error')
        return
      } else {
        toastMessage('Order Created', 'success')
        data = orderData
      }
    })

    orderId = data?.id
    const options = {
      key: RAZORPAYKEY,
      amount: data?.amount,
      name: 'NGX',
      order_id: data?.id,
      description: 'Subscription Payment',
      prefill: {
        name: '',
        email: '',
        contact: '',
        method: ''
      },
      modal: {
        confirm_close: true,
        escape: false
      },

      timeout: 600
    }
    options.modal.ondismiss = dismissModel.bind(this)
    options.handler = razorPaySuccessHandler.bind(this)

    const paymentObject = new window.Razorpay(options)
    let success
    if (renewFlag === true || upgradeFlag === true) {
      success = onPayPerUserPurchaseOrderSave()
    } else {
      success = onOrderUpdateClick()
    }
    if (success) {
      setPendingOrderPaymentDrawerVisibility(false)
      setBuyUserDrawerVisiblity(false)
      setRenewDrawerVisiblity(false)
      paymentObject.open()
    }
  }

  function razorPaySuccessHandler(response) {
    let bodyData
    let purchase_order_id1 = purchase_order_id
    if (renewFlag === true) {
      renewOrderObj.id = purchase_order_id1
      renewOrderObj.status = 'Success'
      renewOrderObj.payment_through = 'Razorpay'
      renewOrderObj.payment_order_id = response.razorpay_order_id
      renewOrderObj.transaction_id = response.razorpay_payment_id
      bodyData = renewOrderObj
    } else if (upgradeFlag === true) {
      orderObj.id = purchase_order_id1
      orderObj.status = 'Success'
      orderObj.payment_through = 'Razorpay'
      orderObj.payment_order_id = response.razorpay_order_id
      orderObj.transaction_id = response.razorpay_payment_id
      bodyData = orderObj
    } else {
      orderObj.id = selectedData._id
      orderObj.status = 'Success'
      orderObj.payment_through = 'Razorpay'
      orderObj.payment_order_id = response.razorpay_order_id
      orderObj.transaction_id = response.razorpay_payment_id
      bodyData = orderObj
    }
    updatePurchaseOrderService(bodyData, (success, error) => {
      if (error) {
        toastMessage(
          'Subscrption update failed.\nIf Amount is debitted from your account, contact NGX',
          'error'
        )
        dismissModel(null, true)
      } else {
        toastMessage('Payment Done Successfully', 'success')
        let payLoad = {
          pageNumber: 1,
          limit: 100,
          status: 'Pending'
        }
        fetchPendingPurchaseOrderService(payLoad)
        payLoad.status = 'Success'
        payLoad.limit = 1
        fetchLastSuccessPurchaseOrderService(payLoad)
        delete payLoad.status
        payLoad.limit = limit
        fetchPurchaseOrderService(payLoad)
        fetchEntitlement()
      }
    })
  }

  async function dismissModel(response, isPaymentSuccess = false) {
    let bodyData
    if (renewFlag === true) {
      renewOrderObj.id = purchase_order_id
      renewOrderObj.status = 'Failed'
      renewOrderObj.payment_through = 'Razorpay'
      renewOrderObj.payment_order_id = orderId
      bodyData = renewOrderObj
    } else if (upgradeFlag === true) {
      orderObj.id = purchase_order_id
      orderObj.status = 'Failed'
      orderObj.payment_through = 'Razorpay'
      orderObj.payment_order_id = orderId
      bodyData = orderObj
    } else {
      orderObj.id = selectedData._id
      orderObj.status = 'Failed'
      orderObj.payment_through = 'Razorpay'
      orderObj.payment_order_id = orderId
      bodyData = orderObj
    }

    await updatePurchaseOrderService(bodyData, (success, error) => {
      if (error) {
        toastMessage('Subscription update failed', 'error')
      } else {
        let payLoad = {
          pageNumber: 1,
          limit: 100,
          status: 'Pending'
        }
        fetchPendingPurchaseOrderService(payLoad)
        payLoad.status = 'Success'
        payLoad.limit = 1
        fetchLastSuccessPurchaseOrderService(payLoad)
        delete payLoad.status
        payLoad.limit = 10
        fetchPurchaseOrderService(payLoad)
      }
    })
    if (!isPaymentSuccess) toastMessage('Payment cancelled', 'error')
  }

  async function onOrderClick(order) {
    order_selected = order
    let tilldate = new Date(entitlementData?.expiry_date)
    if (order.purchased_items[0].purchasetype.short_name == 'Renew')
      tilldate.setDate(
        tilldate.getDate() + order?.purchased_items[0]?.plan?.plan_duration
      )

    let Cdate = convert(tilldate)
    order.tillDate = Cdate
    setSelectedData(order)
    setNoOfUsers(order.no_of_users)
    setPendingOrderPaymentDrawerVisibility(true)
    if (order.purchased_items[0].purchasetype.short_name == 'Renew')
      calculateOrderBeforeLoad(order.no_of_users)
    else calculateBuyNewUserOrder(order.no_of_users)
  }

  function onSaveBuyUserClick() {
    let usersCount
    if (noOfUsers != null || noOfUsers != undefined || noOfUsers != '')
      usersCount = parseInt(noOfUsers)
    else usersCount = 0
    if (usersCount == 0 || isNaN(usersCount)) return

    let purchase_order_type
    for (let i = 0; i < subsOrderTypeData?.length; i++) {
      if (subsOrderTypeData[i].short_name === 'New') {
        purchase_order_type = subsOrderTypeData[i]
        break
      }
    }
    orderObj = {
      no_of_users: parseInt(noOfUsers),
      total_amount: parseInt(total),
      credit_note: parseInt(fetchEntitlementData.credit_note),
      net_amount: parseInt(net_amount),
      purchase_for_days: parseInt(purchaseForDays),
      purchased_items: [
        {
          plan_id: currentPlan?._id,
          purchase_type_id: purchase_order_type._id,
          unit_price: currentPlan?.price_per_user,
          qty: parseInt(noOfUsers),
          free_users: 0,
          fixed_charge: 0,
          cgst: currentPlan?.igst / 2,
          sgst: currentPlan?.igst / 2,
          igst: currentPlan?.igst,
          sgst_amount: sgstAmt,
          cgst_amount: cgstAmt,
          igst_amount: igstAmt
        }
      ]
    }

    if (net_amount === 0) {
      setUpgradeFlag(true)
      updatePurchaseOrder()
    } else if (net_amount > 0) {
      displayRazorpay()
    }
  }

  function pending_order_payment() {
    let usersCount
    if (noOfUsers != null || noOfUsers != undefined)
      usersCount = parseInt(noOfUsers)
    else usersCount = 0
    if (usersCount == 0 || isNaN(usersCount)) return

    if (net_amount === 0) {
      onPendingOrderUpdateClick()
    } else if (net_amount > 0) {
      displayRazorpay()
    }
  }

  return (
    <>
      <Helmet title="Subcriptions" />
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Grid item xs={9}>
          <Typography variant="h4" gutterBottom display="inline">
            Account Details
          </Typography>
        </Grid>
      </Grid>
      <Divider sx={{ marginTop: 5, marginBottom: 5 }} />
      {fetchEntitlementError ? (
        <ErrorScreen
          onClick={() => {
            fetchEntitlementOnError()
          }}
        />
      ) : (
          <Grid container direction="column">
            {/* Entitlements */}
            {/* <Grid item>
            <EntitlementInfoComponent
              initialValues={fetchEntitlementData}
              currentDate={TodayDate}
              onBuyUsers={() => {
                setTotal(0)
                setSgstAmt(0)
                setIgstAmt(0)
                setCgstAmt(0)
                setNetAmount(0)
                setSubTotal(0)
                setNoOfUsers(0)
                setPurchaseForDays(0)
                onClickBuyUsers()
              }}
              onRenew={async () => {
                setTotal(0)
                setSgstAmt(0)
                setIgstAmt(0)
                setCgstAmt(0)
                setNetAmount(0)
                setSubTotal(0)
                setPurchaseForDays(0)
                await onClickRenewOrder()
              }}
              onViewHistory={() => setPaymentDialogVisibility(true)}
              dueDate={dueDate}
              previousPaidAmount={
                fetchLastSuccessPurchaseOrderServiceData[0]?.total_amount
              }
            />
          </Grid> */}
            <Grid item sx={{ marginTop: 2 }}>
            {/* Current Plan */}
            <CurrentPlanComponent
              title={'Subscription Details'}
              initialValues={fetchEntitlementData}
              onChangePlan={() => {
                if (entitlementData?.active == 'Cancelled') {
                  history('/myAccount/subscriptionplans')
                } else {
                  handleClickOpenCancelPopup()
                }
              }}
            />
          </Grid>
          {fetchPendingPurchaseOrderServiceData.data?.length > 0 ? (
            <Grid item>
              {/* Pending orders */}
              <Grid
                justifyContent="space-between"
                container
                spacing={2}
                style={{ marginTop: 15 }}
              >
                <Grid item>
                  <Typography
                    variant="h6"
                    gutterBottom
                    display="inline"
                    style={{ paddingTop: 10 }}
                  >
                    Order
                  </Typography>
                </Grid>
              </Grid>
              <Divider my={4} />
              <Grid container spacing={10} sx={{ paddingTop: 5 }}>
                <Grid item md={10} lg={8}>
                  <Card raised sx={{ borderRadius: 3 }}>
                    <CardContent sx={{ flexGrow: 1 }}>
                      <TableContainer component={Card}>
                        <Table size="small">
                          <TableHead>
                            <StyledTableRow>
                              <StyledTableCell align="left">
                                No of Users
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {' '}
                                Free Users{' '}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {' '}
                                Unit Price
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {' '}
                                Qty
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {' '}
                                GST{' '}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {' '}
                                Fixed Price{' '}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                Status
                              </StyledTableCell>
                            </StyledTableRow>
                          </TableHead>
                          <TableBody>
                            {fetchPendingPurchaseOrderServiceData.data?.map(
                              (row) => (
                                <StyledTableRow
                                  key={row._id}
                                  hover
                                  onClick={() => {
                                    onOrderClick(_.cloneDeep(row))
                                  }}
                                >
                                  <StyledTableCell
                                    align="left"
                                    component="th"
                                    scope="row"
                                  >
                                    {row.no_of_users}
                                  </StyledTableCell>
                                  <StyledTableCell align="left">
                                    {row?.purchased_items[0]?.free_users}
                                  </StyledTableCell>
                                  <StyledTableCell align="left">
                                    {row?.purchased_items[0]?.unit_price}
                                  </StyledTableCell>
                                  <StyledTableCell align="left">
                                    {row?.purchased_items[0]?.qty}
                                  </StyledTableCell>
                                  <StyledTableCell align="left">
                                    {row?.purchased_items[0]?.igst} %
                                  </StyledTableCell>
                                  <StyledTableCell align="left">
                                    {row?.purchased_items[0]?.fixed_charge}
                                  </StyledTableCell>
                                  <StyledTableCell align="left">
                                    {' '}
                                    {row.status}{' '}
                                  </StyledTableCell>
                                </StyledTableRow>
                              )
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
      )}

      <PaymentHistory
        visibility={paymentHistoryDialogVisibility}
        initialValues={fetchPurchaseOrderServiceData?.data}
        title={'Payment History'}
        onClose={() => setPaymentDialogVisibility(false)}
        onPageChange={(value) => {
          setPage(value)
          let payLoad = {
            pageNumber: value,
            limit: limit
          }
          fetchPurchaseOrderService(payLoad)
        }}
        pagecount={pagecount}
        page={page}
      />

      <PendingOrdersPaymentDrawer
        title={'Order Details'}
        visible={pendingOrderPaymentDrawerVisibility}
        entitlementData={fetchEntitlementData}
        orderDetails={selectedData}
        onChangeUserCount={(value) => {
          calculateBuyNewUserOrder(value)
        }}
        onCancelOrder={() => {
          onOrderCancelClick()
        }}
        onClose={() => {
          setPendingOrderPaymentDrawerVisibility(false)
        }}
        onSave={() => {
          if (noOfUsers <= 0) return
          onOrderUpdateClick()
        }}
        onPayment={() => {
          if (noOfUsers <= 0) return
          pending_order_payment()
        }}
        noOfUsers={noOfUsers}
        calculationData={{
          subtotal: subtotal,
          total: total,
          net_amount: net_amount
        }}
      />
      <BuyNewOrderDrawer
        title={'User Account Purchase'}
        visible={buyUserDrawerVisibility}
        entitlementData={fetchEntitlementData}
        currentPlan={fetchPlanByIdData}
        onChangeUserCount={(value) => {
          calculateBuyNewUserOrder(value)
        }}
        onClose={() => {
          setBuyUserDrawerVisiblity(false)
        }}
        onSubmit={() => {
          if (noOfUsers <= 0) return
          onSaveBuyUserClick()
        }}
        noOfUsers={noOfUsers}
        calculationData={{
          subtotal: subtotal,
          total: total,
          net_amount: net_amount
        }}
      />

      <RenewSubscriptionDrawer
        title={'Subscription Renewal'}
        visible={renewDrawerVisibility}
        entitlementData={fetchEntitlementData}
        currentPlan={fetchPlanByIdData}
        onSubmit={() => displayRenewalRazorpay()}
        onClose={() => {
          setRenewDrawerVisiblity(false)
        }}
        noOfUsers={noOfUsers}
        calculationData={{
          subtotal: subtotal,
          total: total,
          net_amount: net_amount
        }}
      />
      <div>
        <Snackbar
          open={snackbar}
          autoHideDuration={SnackBarHideDuration}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={handleSnackbarClose}
          TransitionComponent={SnackBarTransition}
        >
          <Alert onClose={handleSnackbarClose} severity={severity}>
            {PopUpMessage}
          </Alert>
        </Snackbar>
      </div>

      <PlanCancelPopUpDialog />
    </>
  )
}

export default Orders
